import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { ROUTES } from '@futrli/shared-services';

import { ForecastingOnboardingContainer } from '../../onboarding/forecasting-onboarding-container';
import { ImportOrganisation } from '../reports/external-sheets/import/containers/import-organisation/import-organisation';
import { PredictionsNavDataControls } from '../predictions/predictions-nav-data-controls/predictions-nav-data-controls';
import { PredictionsRouterUKV2 } from '../predictions/predictions-nav-data-controls/predictions-router-uk-v2';
import { SidePanelContextProvider } from './side-panel';

export const ForecastContainerUK = () => {
  return (
    <SidePanelContextProvider>
      <Routes>
        <Route path={`${ROUTES.ONBOARDING_ROUTE}/*`} element={<ForecastingOnboardingContainer />} />
        <Route path={`${ROUTES.IMPORT}/*`} element={<ImportOrganisation />} />
        <Route
          path={`${ROUTES.PREDICTIONS}/*`}
          element={
            <PredictionsNavDataControls>
              <PredictionsRouterUKV2 />
            </PredictionsNavDataControls>
          }
        />
      </Routes>
    </SidePanelContextProvider>
  );
};
